import React, { ReactNode, FC, useCallback, ComponentType, HTMLAttributes } from 'react';

import { SCP } from 'ia-react-core/~/interfaces/SCP';
import { WithAnalytics } from 'ia-react-core/~/interfaces/WithAnalytics';
import { StyledButton, StyledLeftIcon, StyledRightIcon } from './MainFooterButton.styles';

export interface MainFooterButtonProps extends WithAnalytics, SCP<'button'> {
  /** The button content */
  children?: ReactNode;
  /** Icon to display left of the button  */
  LeftIcon?: ComponentType<HTMLAttributes<SVGElement>>;
  /** Icon to display right of the button  */
  RightIcon?: ComponentType<HTMLAttributes<SVGElement>>;
}

const MainFooterButton: FC<MainFooterButtonProps> = ({ children, LeftIcon, RightIcon, ...props }) => {
  const FilteredLeftIcon = useCallback(({ className }: SCP<'svg'>) =>
    <LeftIcon className={className} />, [LeftIcon]);
  const FilteredRightIcon = useCallback(({ className }: SCP<'svg'>) =>
    <RightIcon className={className} />, [RightIcon]);

  return (
    <StyledButton
      data-testid="MainFooterButton"
      {...props}
    >
      {LeftIcon && <StyledLeftIcon as={FilteredLeftIcon} />}
      {children}
      {RightIcon && <StyledRightIcon as={FilteredRightIcon} />}
    </StyledButton>
  );
};

export default MainFooterButton;
